<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Ημερομηνία -
              <span style="color:#556ee6">{{
                new Date().toLocaleDateString()
              }}</span>
            </h4>
            <p class="card-title-desc"></p>

            <b-spinner
              v-show="spinner"
              class="m-2"
              variant="primary"
              role="status"
            ></b-spinner>
            <p v-if="spinner">{{ spinnerMsg }}</p>
            <p v-if="lastUpdateMsg" style="font-size:18px">
              Τελευταία ανάγνωση ρολογιών :
              {{ lastUpdateMsg.last_update.split(" ")[1] }}
            </p>

            <!-- <div class="button-style">
              <b-button @click="updatePage" variant="primary">Ανανέωση</b-button>
              </div> -->
            <div class="col-12 col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="mt-3">
                      Τμήματα:
                    </label>
                    <multiselect
                      placeholder="Επιλογή τμημάτων"
                      :options="departmentNames"
                      v-model="departmentValue"
                      selectLabel="Eπιλογή Τμήματος"
                      selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"
                      :multiple="true"
                      track-by="id"
                      label="name"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="mt-3">Ονομα Χρήστη:</label>
                    <multiselect
                      v-model="personOptionValue"
                      :options="peopleOptions"
                      placeholder="Επιλέξτε Χρήστη"
                      selectLabel="Eπιλογή Χρηση"
                      selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"
                      :multiple="true"
                      :max="1"
                      track-by="id"
                      label="name"
                    ></multiselect>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Κατάσταση:</label>
                    <multiselect
                      v-model="statusAttendanceOption"
                      :options="attendanceOptions"
                      placeholder="Επιλέξτε"
                      selectLabel="Eπιλογή"
                      selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Α/Α</th>
                    <th>Όνομα</th>
                    <!-- <th v-if="!IsmissedPeople">Αρ.κάρτας</th> -->
                    <!-- <th>Ημερομηνία</th> -->
                    <th>Άφιξη</th>
                    <th>Αποχώρηση</th>
                    <!-- <th v-if="!IsmissedPeople">Ρολόι</th> -->
                    <th v-if="userAttendance != '' && !IsmissedPeople">
                      Κατάσταση
                    </th>
                    <th>Παρατηρήσεις</th>
                  </tr>
                </thead>

                <!-- start of missing people -->

                <MissedPeopleTable
                  v-if="IsmissedPeople == null || IsmissedPeople == true"
                  :missedPeople="missedPeople"
                ></MissedPeopleTable>

                <tbody v-if="!IsmissedPeople">
                  <tr v-for="(attendance, index) in attendances" :key="index">
                    <th scope="row">
                      {{
                        IsmissedPeople != null || IsmissedPeople == true
                          ? index + 1
                          : index + 1 + lastMissingKey
                      }}
                      <!-- {{
                        attendances.current_page * perPage - perPage + index + 1
                      }} -->
                    </th>
                    <td>
                      {{
                        attendance.person_full_name
                          .split(" ")
                          .reverse()
                          .join(" ")
                      }}
                    </td>
                    <!-- <td>{{ attendance.person_card_number }}</td> -->
                    <!-- 
                    <td>
                      {{
                        attendance.timestamp
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                      }}
                      
                    </td> -->
                    <div
                      v-for="(result, idx) in parser_timestamps_in(
                        attendance.collect_timestamps
                      )"
                      :key="idx + 'A'"
                    >
                      <td>
                        {{ result.timestamp.split(" ")[1] }} -
                        {{ result.device }}
                      </td>
                    </div>

                    <td>
                      <div
                        v-for="(result, idx) in parser_timestamps_out(
                          attendance.collect_timestamps
                        )"
                        :key="idx"
                      >
                        <td>
                          {{ result.timestamp.split(" ")[1] }} -
                          {{ result.device }}
                        </td>
                      </div>
                    </td>
                    <!-- <div
                      v-for="(collect_timestamp,
                      index) in attendance.collect_timestamps"
                      :key="index"
                    >
                      <td v-if="index % 2 == 1">
                        {{ collect_timestamp.timestamp }}
                      </td>
                    </div> -->
                    <!-- <td>{{ attendance.device }}</td> -->
                    <td v-if="userAttendance != ''">
                      {{ statuses(index + 1) }}
                    </td>
                  </tr>
                </tbody>

                <!-- <tbody v-if="IsmissedPeople">
                  <tr v-for="(missPerson, index) in missedPeople" :key="index">
                    <th scope="row">{{ index + 1 }}</th>

                    <td>
                      {{ missPerson.person_last_name }}
                      {{ missPerson.person_first_name }}
                    </td>
                    <td>
                      {{
                        new Date()
                          .toLocaleDateString()
                          .split("/")
                          .join("-")
                      }}
                    </td>
                    <td v-if="missPerson.is_on_holidays != null">
                      {{ missPerson.is_on_holidays }}
                    </td>
                  </tr>
                </tbody> -->
                <!-- end of missing people -->
              </table>
            </div>
            <!-- <div class="row" v-if="IsmissedPeople">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    v-if="missedPeople.results"
                  >
                    {{
                      missedPeople.results.count
                    }}
                 
                    <b-pagination
                      v-model="missCurrentPage"
                      :total-rows="missedPeople.count"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div> -->
            <!-- <div class="row" v-if="!IsmissedPeople && IsmissedPeople != null">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    v-if="attendances.results"
                  >
                    {{
                      attendances.results.count
                    }}
                    
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="attendances.count"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import { mapState, mapGetters } from "vuex";
import PageHeader from "@/components/page-header";
import session from "../../../../api/session";
import Multiselect from "vue-multiselect";
import MissedPeopleTable from "@/components/stuffComponents/status_missing";

export default {
  page: {
    title: "Τρέχουσα κατάσταση",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect, MissedPeopleTable },
  data() {
    return {
      title: "Τρεχουσα κατασταση",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Τρέχουσα κατάσταση",
          active: true,
        },
      ],
      personOptionValue: "",
      attendances: [],
      missCurrentPage: 1,
      currentPage: 1,
      perPage: 100,
      filter: "",
      intervals: "",
      departmentValue: "",
      peopleFilters: {
        currentPage: 1,
        department: "",
        person: "",
      },
      userAttendance: "",
      spinner: true,
      missingAttendances: [],
      attendanceOptions: ["Παρών", "Απών"],
      statusAttendanceOption: "",
      clockin: "",
      spinnerMsg: "",
      currentDate: new Date().toISOString().split("T")[0],
      IsmissedPeople: null,
      missedPeople: [],
      peopleFilter: {
        department: "",
      },
      lastUpdateMsg: "",
      personValue: "",
      depValue: "",
      status: "",
      workingScheduleFilters: {
        department: "",
        personId: "",
      },
      lastMissingKey: 1,
    };
  },
  created() {
    this.fetchAttendances();
    this.fetchMissingPeople();
    // this.collectAttendances();
    this.fetchMissingAttendances();
    this.lastCollectedattendances();
  },
  watch: {
    departmentValue(value) {
      this.departmentValue = value;
      this.depValue = value;
      if (this.status === "Απών") {
        this.fetchMissingPeople();
        return;
      }
      this.fetchMissingPeople();
      this.fetchAttendances();
    },
    personOptionValue(value) {
      this.personOptionValue = value;

      if (this.status === "Απών") {
        this.fetchMissingPeople();
        return;
      }

      if (this.status === "Παρών") {
        this.userAttendance = "";
        this.fetchAttendances();

        return;
      }

      this.fetchMissingPeople();

      this.userAttendance = "";
      this.fetchAttendances();
    },

    statusAttendanceOption(value) {
      this.status = value;
      if (value == null) {
        this.status = value;
        this.IsmissedPeople = value;
        return;
      }

      if (value === "Απών") {
        this.IsmissedPeople = true;
        this.fetchMissingPeople();
        return;
      } else {
        this.IsmissedPeople = false;
      }
    },
  },
  computed: {
    ...mapState("utils", ["departmentOptions", "peopleOptionFields"]),
    ...mapGetters("auth", ["userLoggedIn", "is_staff", "is_superuser"]),

    departmentNames() {
      this.preFillDepartmentValue();
      // return this.departmentOptions.map((e) => `${e.parent_name}/${e.name}`);
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    peopleOptions() {
      if (this.departmentValue && this.departmentValue.id) {
        return this.peopleOptionFields
          .filter((e) => {
            return e.department.includes(this.departmentValue.id);
          })
          .map((e) => {
            return { id: e.id, name: e.person_full_name };
          });
      } else {
        return this.peopleOptionFields.map((e) => {
          return { id: e.id, name: e.person_full_name };
        });
      }
    },
  },
  methods: {
    // ...mapActions("utils", ["fetchPeopleOptionFields"]),
    preFillDepartmentValue() {
      if (!(this.is_staff || this.is_superuser)) {
        this.departmentValue = this.departmentOptions.map(
          (e) => `${e.parent_name}/${e.name}`
        )[0];
      }
    },
    parser_timestamps_in(timestamps) {
      const now = timestamps.map((e, idx) => {
        if (idx % 2 == 0) {
          return e;
        }
      });

      return now.filter((o) => o != null);
    },
    parser_timestamps_out(timestamps) {
      const now = timestamps.map((e, idx) => {
        if (idx % 2 == 1) {
          return e;
        }
      });

      return now.filter((o) => o != null);
    },

    async lastCollectedattendances() {
      await session.get("api/last_update_device/").then((resp) => {
        this.lastUpdateMsg = resp.data;
      });
    },

    async fetchMissingPeople() {
      const missingPeopleParams = {
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
      };

      const params = new URLSearchParams(missingPeopleParams);

      Object.values(this.departmentValue).forEach((value) => {
        params.append("department", value.id);
      });

      this.spinner = true;
      this.spinnerMsg = "Παρακαλώ περιμένετε...";
      await session
        .get(`api/current-status/missing/?${params.toString()}`)
        .then((resp) => {
          this.missedPeople = resp.data;
          this.lastMissingKey = resp.data.length;
        });
      this.spinner = false;
      this.spinnerMsg = "";
    },

    async fetchMissingAttendances() {
      await session
        .get(`api/attendances/missing/?timestamp=${this.currentDate}`)
        .then((resp) => {
          this.missingAttendances = resp.data;
        });
    },
    // ...mapActions("people", ["fetchAllPeople", "fetchPeopleByFilters"]),
    statuses(index) {
      if (index % 2 == 1) {
        return "Έξοδος";
      } else {
        return "Είσοδος";
      }
    },
    async fetchAttendances() {
      this.spinner = true;
      this.spinnerMsg = "Παρακαλώ περιμένετε...";
      // const filters = this.peopleFilters.department;
      const attendanceParams = {
        timestamp: this.currentDate,
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        // department:
        //   this.departmentValue.length > 0 ? this.departmentValue[0].id : "",
      };

      const attendanceRequestParams = new URLSearchParams(attendanceParams);

      Object.values(this.departmentValue).forEach((value) => {
        attendanceRequestParams.append("department", value.id);
      });

      await session
        .get(`api/attendances/?${attendanceRequestParams.toString()}`)
        .then((resp) => {
          this.attendances = resp.data;
        });
      this.spinner = false;
      this.spinnerMsg = "";
    },
  },
};
</script>

<style scoped>
.button-style {
  position: absolute;
  left: 90%;
}
</style>
